import { useState,useRef, } from "react";
import { useEffect } from "react";
import WebService from "../../Services/WebService";
import WebUrl from "../../Services/WebUrl";
function AddBrand() {

  const[msg,setMsg] = useState()
  const[list,setList] = useState([])

  var brand_name = useRef()

  var addBrand = async (event)=>{
    event.preventDefault()
    var brandName = brand_name.current.value
    console.log(brandName)
    var obj = {serviceType:brandName}
    console.log(obj)
    setList([...list,obj])

    var result = await WebService.postAPI(WebUrl.add_brand,obj);
    console.log(result.data)
    if(result.status)
    {
      setMsg('Brand Added....')
    }
  }

  useEffect(()=>{
    loadBrandData()
 },[])

  var loadBrandData = async  ()=>{
     var brand_name = await WebService.getAPI(WebUrl.load_brand)
     console.log("brand list",brand_name.data)
     setList(brand_name.data.data)
  }

  return<main id="main" className="main">
   <section className="section">
    <div className="row">
      <div className="col-lg-12">

        <div className="card">
          <div className="card-body">
            <h5 className="card-title">Add Services Type : </h5>

            {/* General Form Elements */}
            <form onSubmit={addBrand}>
              <div className="row mb-3">
                <label for="inputText" className="col-sm-2 col-form-label">Enter Service Type</label>
                <div className="col-sm-10">
                  <input type="text" ref={brand_name} placeholder="Enter Service Type" className="form-control"/>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-sm-10">
                  <button type="submit" className="btn btn-primary">Submit Service Type</button>
                </div>
              </div>
            </form>{/* End General Form Elements */}
    <h1>{msg}</h1>
          </div>
        </div>
        <h1 style={{textAlign:'center'}}>Service Type List : </h1>
        <br/><br/>
        <div className="table-responsive">
            <table className="table table-bordered table-hover table-striped" style={{ border: '4px solid black' }}>
              <thead>
              <tr>
                 <th>S.No</th>
                 <th>Service Id</th>
                 <th>Service Type Name</th>
                 <th>Operation</th> 
              </tr>
              </thead>

            <tbody>
            {/* {list.map((res,index)=>{ */}
            
              {list.map((res,index)=>{
                return<tr>
                  <td>{index+1}</td>
                  <td>{res.id}</td>
                  <td>{res.serviceType}</td>
                  <button style={{ backgroundColor: '#007bff', color: '#fff', border: 'none', padding: '5px 10px', cursor: 'pointer' }}>Update</button> 
                <button style={{ backgroundColor: '#dc3545', color: '#fff', border: 'none', padding: '5px 10px', cursor: 'pointer' }}>Delete</button>
                </tr>
              })}
            </tbody>

            </table>
           


            </div>

      </div>

      
    </div>
  </section>

</main>
}

export default AddBrand;
